import React, { useContext } from "react";
import { FaSync, FaPlus, FaFileExcel, FaTimes, FaRegArrowAltCircleLeft } from "react-icons/fa";
import { SettingGeneralContext } from "../../context/settingGeneralContext";
import { Row } from "react-bootstrap";
import { FaUsersBetweenLines } from "react-icons/fa6";


const HeaderReusable = ({
  title,
  icon: Icon,
  isTabletOrMobile = false,
  query,
  setQuery,
  searchData = true,
  limit,
  setLimit,
  setPage,
  onAdd,
  onRefresh,
  showAddButton = true,
  showEntriesButton = true,
  showRefreshButton = true,
  showCustomButton = false,
  showResetButton = false,
  showCustomButtonBack = false,
  showCustomButtonRelationPatient = false,
  handleModalRelationPatient,
  handleReset,
  handleFileUpload,
  handleClose = false,
  IconOrTitleAdd = <FaPlus />,
  handleCloseSubmit,
}) => {

  const context = useContext(SettingGeneralContext);
  const state = context?.state || {};
  const appSidebarColor1 = state?.showTheme?.app_sidebar_color_1;
  const appSidebarColor2 = state?.showTheme?.app_sidebar_color_2;
  const appSidebarColor3 = state?.showTheme?.app_sidebar_color_3;
  const appSidebarColor4 = state?.showTheme?.app_sidebar_color_4;
  const appSidebarColor5 = state?.showTheme?.app_sidebar_color_5;


  const commonButtonStyle = {
    fontSize: "12px",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    borderRadius: "3px",
    padding: "5px 10px",
  };

  const commonInputStyle = {
    backgroundColor: "#E9E9E9",
    border: "none",
    height: "100%",
    padding: "0px 10px",
  };

  return (
    <>

      <div
        style={{
          width: "100%",
          borderBottom: "5px solid #EEEEEE",
          display: "flex",
          padding: isTabletOrMobile ? "0px 0px 10px 0px" : "10px 0px",
        }}
      >
        {/* Kolom Judul */}
        <div
          style={{
            flex: isTabletOrMobile ? "none" : "50%",
            fontSize: "16px",
            display: "flex",
            alignItems: "center",
            paddingLeft: isTabletOrMobile ? "0" : "10px",
            color: appSidebarColor4 ?? "#001F8B",
            justifyContent: isTabletOrMobile ? "center" : "flex-start",
            backgroundColor: isTabletOrMobile ? "#E9EFFF" : "transparent",
          }}
        >
          {showCustomButtonBack &&
            <>
              <div onClick={() => window.history.back()} style={{ display: "flex", marginRight: "10px", fontSize: "11px", color: "white", backgroundColor: "#ABC1FF", padding: "5px 10px", borderRadius: "3px", cursor: "pointer", border: "none", borderTopLeftRadius: "30px", borderBottomLeftRadius: "30px" }}>
                <div style={{ marginRight: "3px", display: "flex" }}>
                  <div style={{ display: "flex", alignItems: "center", height: "100%" }}>
                    <FaRegArrowAltCircleLeft style={{ display: "flex", alignItems: "center", fontSize: "15px" }} />
                  </div>
                </div>
                <div style={{ display: "flex" }}>
                  <div style={{ display: "flex", alignItems: "center", height: "100%", fontSize: "12px" }}>
                    Kembali
                  </div>
                </div>
              </div>
            </>
          }
          {Icon && <Icon style={{ marginRight: "5px" }} />}
          {title}
        </div>


        <div style={{ flex: "50%", display: "flex", justifyContent: "end", paddingRight: "10px" }}>
          {/* Dropdown Show Entries */}
          {showEntriesButton && (
            <>
              <div style={{ display: "flex", alignItems: "center", marginRight: "10px", fontSize: "13px" }}>
                <span style={{ marginRight: "5px" }}>Show</span>
                <select
                  onChange={(e) => {
                    const newLimit = Number(e.target.value);
                    setPage(1);
                    setLimit(newLimit);
                  }}
                  value={limit}
                  style={{
                    height: "28px",
                    fontSize: "13px",
                    padding: "2px 6px",
                    marginRight: "5px",
                    borderRadius: "4px",
                    border: "1px solid #ccc",
                    cursor: "pointer"
                  }}
                >
                  <option value={10}>10</option>
                  <option value={25}>25</option>
                  <option value={50}>50</option>
                  <option value={100}>100</option>
                </select>
                <span>Entries</span>
              </div>
            </>
          )}
          {/*Open Tombol Excel (Opsional) */}
          {showCustomButton && (
            <>
              <div style={{ display: "flex", justifyContent: "end" }}>
                <div style={{ display: "flex", justifyContent: "end" }}>
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "5px",
                      backgroundColor: "#00CC66",
                      color: "white",
                      borderRadius: "3px",
                      cursor: "pointer",
                      fontSize: "12px"
                    }}
                  >
                    <label
                      htmlFor="file-upload"
                      style={{ display: "flex", alignItems: "center", cursor: "pointer", padding: "0px 10px" }}
                    >
                      <FaFileExcel style={{ cursor: "pointer" }} />
                    </label>
                    <input
                      id="file-upload"
                      type="file"
                      onChange={handleFileUpload}
                      style={{ display: "none" }}
                    />
                  </div>
                </div>
              </div>
            </>
          )}
          {/* Close Tombol Excel (Opsional) */}

          {showAddButton && (
            <div
              onClick={onAdd}
              style={{
                ...commonButtonStyle,
                backgroundColor: appSidebarColor2 ?? "#3D64FF",
                color: "white",
                marginRight: "5px",
              }}
            >
              {IconOrTitleAdd}
            </div>
          )}

          {showRefreshButton && (
            <div
              onClick={onRefresh}
              style={{
                ...commonButtonStyle,
                backgroundColor: "white",
                border: `1px solid ${appSidebarColor1}` ?? `1px solid #DEDEDE`,
                color: "#3D64FF",
                marginRight: "5px",
              }}
            >
              <FaSync style={{ fontSize: "15px", color: `${appSidebarColor2}` }} />
            </div>
          )}

          {/*Open Tombol Hubungan Pasien (Opsional) */}
          {showCustomButtonRelationPatient &&
            <>
              <div
                onClick={handleModalRelationPatient}
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginRight: "5px",
                  backgroundColor: appSidebarColor2 ?? "#3D64FF",
                  color: "white",
                  padding: "0px 12px",
                  borderRadius: "3px",
                  fontSize: "15px",
                  cursor: "pointer"
                }}
              >
                <FaUsersBetweenLines />
              </div>
            </>
          }
          {/*Close Tombol Hubungan Pasien (Opsional) */}

          {showResetButton && (
            <button
              onClick={handleReset}
              style={{
                ...commonButtonStyle,
                backgroundColor: appSidebarColor3 ?? "#3D64FF",
                color: "white",
                fontWeight: "600",
                marginRight: "5px",
                padding: "0px 10px",
              }}
            >
              Reset
            </button>
          )}

          {/* Form Pencarian */}
          {searchData && (
            <form onSubmit={searchData} style={{ display: "flex", paddingRight: isTabletOrMobile ? "0px" : "10px" }}>
              <input
                value={query}
                onChange={(e) => setQuery(e.target.value)}
                className="focused"
                style={commonInputStyle}
                type="text"
                placeholder="Cari..."
              />
              <button
                type="submit"
                style={{
                  ...commonButtonStyle,
                  backgroundColor: appSidebarColor3 ?? "#3D64FF",
                  color: "white",
                  fontWeight: "600",
                  padding: "0px 10px",
                }}
              >
                Search
              </button>
            </form>
          )}

          {handleClose && (
            <div style={{
              display: "flex",
              alignItems: "center",
              marginRight: "5px",
              backgroundColor: appSidebarColor2 ?? "#3D64FF",
              color: "white",
              padding: "0px 12px",
              borderRadius: "3px",
              fontSize: "15px",
              cursor: "pointer"
            }}>
              <FaTimes onClick={handleCloseSubmit} style={{ cursor: "pointer" }} />
            </div>
          )}
        </div>
      </div>
    </>
  );
};

export default HeaderReusable;
